import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const Linkify = ({ url, content, containerClass = '', linkClass = '', isHidden }) => {
  if (isHidden) {
    return null;
  }
  if(!url) {
    return <div className={`${containerClass} ${linkClass}`.trim()}>{content}</div>;
  }
  return (
    <div className={containerClass}>
      <Link to={url} className={linkClass}>{content}</Link>
    </div>
  );
};

Linkify.propTypes = {
  url: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  containerClass: PropTypes.string,
  linkClass: PropTypes.string,
  isHidden: PropTypes.bool,
};

export default Linkify;
